import axios from 'axios'
import { City } from '../models/city'

const API_URL = process.env.REACT_APP_API_URL

interface CitiesResponse {
  data: City[]
  payload: {
    message: string
    pagination: {
      totalPages: number
      currentPage: number
      pageSize: number
      totalItems: number
    }
    code: number
  }
}

interface CityResponse {
  data: City
  payload: {
    message: string
    code: number
  }
}

export const getCities = async (page: number, pageSize: number): Promise<CitiesResponse> => {
  const response = await axios.get(`${API_URL}/tour-cities?page=${page}&size=${pageSize}`)
  return response.data
}

export const getCity = async (id: string): Promise<CityResponse> => {
  const response = await axios.get(`${API_URL}/tour-cities/${id}`)
  return response.data
}

export const createCity = async (city: Omit<City, '_id'>): Promise<City> => {
  const response = await axios.post(`${API_URL}/tour-cities`, city)
  return response.data
}

export const updateCity = async (id: string, city: Omit<City, '_id'>): Promise<City> => {
  const response = await axios.patch(`${API_URL}/tour-cities/${id}`, city)
  return response.data
}

export const deleteCity = async (id: string): Promise<void> => {
  await axios.delete(`${API_URL}/tour-cities/${id}`)
} 